import { render, staticRenderFns } from "./HighProfileCases.vue?vue&type=template&id=68921ad2"
import script from "./HighProfileCases.vue?vue&type=script&lang=js"
export * from "./HighProfileCases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports